import { AnimatePresence, motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { FormControl, InputGroup, Spinner } from "react-bootstrap";
import { FaPlus, FaSearch, FaSpinner, FaUserCircle, FaUserSlash } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { LabelConstants } from "../../Constants.ts";
import SavingIndicator from "../../UIComponents/SavingIndicator.tsx";
import { UserModel, UserRoles } from "../../_core/_model.ts";
import { AddRemoveUsersRoleGroup, GerUsersRoleGroup, GetUserByRole, GetUserRoles, GetUsers, GetUsersByRoleGroup, UpdateUserRoles } from "../../_core/_request.ts";
import { useAppContext } from "../../context/AppContext.tsx";
import { AuthContext } from "../../context/AuthContext.js";
import { defaultTheme } from "../../styles/themes/defaultTheme.js";
import AdUserDD from "../Tools/AdUserDD.tsx";
import TooltipButton from "../Tools/TooltipButton.tsx";
import { RoleGroup } from "./_core/_model.ts";
import { GetRoleGroups } from "./_core/_request.ts";

interface Props {
    roleId: number;
    roleGroupId: number;
}

export function RoleGroupUsers({ roleId, roleGroupId }: Props) {
    const [users, setUsers] = useState<UserModel[]>([]);
    const [filteredUsers, setFilteredUsers] = useState<UserModel[]>([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const { user: loggedInUser } = useContext(AuthContext);
    const { allUsers, allRoleGroups, setAllRoleGroups, setAllUsers, roles: allRoles } = useAppContext();

    const initMe = () => {
        if (roleId > 0) {
            GetUserByRole(roleId.toString()).then((x) => {
                const rgs = x.data;
                if (rgs.length > 0) {
                    const matchedUsers = allUsers.filter((user: UserModel) =>
                        rgs.some((rg: any) => rg.userID === user.userID)
                    );
                    setUsers(matchedUsers);
                    setFilteredUsers(matchedUsers);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            });
        }
        else {
            if (roleGroupId > 0) {
                GetUsersByRoleGroup(roleGroupId.toString()).then((x) => {
                    const rgs = x.data;
                    if (rgs.length > 0) {
                        const matchedUsers = allUsers.filter((user: UserModel) =>
                            rgs.some((rg: any) => rg.userID === user.userID)
                        );
                        setUsers(matchedUsers);
                        setFilteredUsers(matchedUsers);
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                });
            }
            else {
                setLoading(false);
            }
        }
    }
    useEffect(() => {
        initMe();
    }, [roleId, roleGroupId]);

    useEffect(() => {
        const s = search.toLowerCase();
        setFilteredUsers(
            users.filter(
                (u) =>
                    u.userName.toLowerCase().includes(s) ||
                    u.email.toLowerCase().includes(s)
            )
        );
    }, [search, users]);
    const [showADUser, setShowADUser] = useState<string | null>(null);
    const [actionMessage, setActionMessage] = useState<string>("");

    const AddNewUser = () => {
        let usr = allUsers.find((x) => x.email == showADUser);
        if (typeof usr != 'undefined') {
            let groups: RoleGroup[] = [];
            let roles: UserRoles[] = [];
            const getRoles = (callBack: any) => {
                setActionMessage("Getting users Roles...");
                GetUserRoles(usr.userID).then((x) => {
                    roles = x.data;
                    callBack();
                })
            }
            const getGroups = (callBack: any) => {
                setActionMessage("Getting users Groups...");
                GerUsersRoleGroup(usr.userID).then((x) => {
                    groups = x.data;
                    callBack();
                })
            }
            const updateGroups = (callBack: any) => {
                setActionMessage("Updating Groups...");
                let gIds = groups.map((x) => x.roleGroupID);
                AddRemoveUsersRoleGroup({ roleGroups: gIds, userID: usr.userID, byUser: loggedInUser.userID, prevGroups: [] }).then((x) => {
                    setActionMessage("Saved successfully.");
                    callBack();
                })
            }
            const updateRole = (callBack: any) => {
                let dRoles: { [key: string]: number[] } = {};
                setActionMessage("Applying role changes...");
                for (var indx in roles) {
                    let cRole = roles[indx];
                    if (cRole.roleID != null) {
                        if (typeof dRoles[cRole.dataMapCode] != 'undefined') {
                            dRoles[cRole.dataMapCode].push(cRole.roleID);
                        }
                        else
                            dRoles[cRole.dataMapCode] = [cRole.roleID];
                    }
                }
                UpdateUserRoles({ userID: usr.userID, userRoles: dRoles, byUser: loggedInUser.userID, prevRoles: [] }).then((x) => {
                    //setActionMessage({ type: "success", message: "Saved successfully." });
                    callBack();
                })
            }
            getGroups(() => {
                getRoles(() => {
                    let nGroup = allRoleGroups.find((rg) => rg.roleGroupID == roleGroupId);
                    if (typeof nGroup != 'undefined') {
                        groups.push(nGroup);
                        updateGroups(() => {
                            let rArr = nGroup.roleIDS.split(",");
                            for (var indx in rArr) {
                                if (rArr[indx] != "") {
                                    let nRole = allRoles.find((r) => r.roleID == parseInt(rArr[indx]));
                                    if (typeof nRole != 'undefined' && nRole.roleID != null) {
                                        roles.push({
                                            dataMapCode: nRole.dataMapCode,
                                            roleID: nRole.roleID,
                                            userID: usr.userID
                                        })
                                    }
                                }
                            }
                            updateRole(() => {
                                setActionMessage("Updating Users...");
                                GetUsers({ userID: usr.userID, userName: "", email: "", roleID: null, roleGroupID: null, managerUserID: null, appliationAccess: null }).then((x) => {
                                    let uA = allUsers;
                                    let ind = uA.findIndex((u) => u.userID == usr.userID);
                                    uA[ind] = x.data[0];
                                    setAllUsers([...uA]);
                                    setActionMessage("Updating groups...");
                                    GetRoleGroups({ roleGroupID: roleGroupId.toString(), roleGroupName: "", roleID: "", userID: "" }).then((g) => {
                                        let aG = allRoleGroups;
                                        let ind = aG.findIndex((x) => x.roleGroupID == roleGroupId);
                                        aG[ind] = g.data[0];
                                        setAllRoleGroups([...aG]);
                                        setShowADUser(null);
                                        setActionMessage("");
                                        initMe();
                                    })
                                })
                            })
                        })
                    }
                })
            })
        }
        else
            setShowADUser(null);
    }

    const selectedUserId = () => {
        let uId = 0;
        if (showADUser != "") {
            let u = allUsers.find((u) => u.email == showADUser);
            if (typeof u != 'undefined')
                uId = u.userID;
        }
        return uId;
    }

    const uName = (email: string) => {
        let name = allUsers.find((u) => u.email == email)?.userFirstName;
        if (name == "")
            name = allUsers.find((u) => u.email == email)?.userFirstName + " " + allUsers.find((u) => u.email == email)?.userLastName;
        return name;
    }

    const AddUserUI = () => {
        return (
            <AnimatePresence>
                {showADUser != null ? (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: 30 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 30 }}
                        transition={{ duration: 0.35, ease: "easeOut" }}
                        className="mt-3 border border-success border-2 rounded shadow-lg p-3 bg-theme-card"
                    >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0">Add User to <strong>"{allRoleGroups.find((x) => x.roleGroupID == roleGroupId)?.roleGroupName}"</strong> Group</h6>
                            <TooltipButton title="Close">
                                <button className="btn btn-sm btn-outline-danger p-0" onClick={() => setShowADUser(null)}>
                                    <span style={{ padding: "1px 4px 4px 4px" }} className="d-block">
                                        <IoCloseSharp />
                                    </span>
                                </button>
                            </TooltipButton>
                        </div>
                        {
                            actionMessage != "" ?
                                <motion.div
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: 10 }}
                                    style={{
                                        position: "fixed",
                                        bottom: 20,
                                        left: 0,
                                        right: 0,
                                        margin: "0 auto",
                                        zIndex: 1055,
                                        width: "fit-content",
                                        maxWidth: "90%",
                                        pointerEvents: "none", // Optional: allows clicks to pass through
                                    }}
                                    className={`alert mt-3 alert-warning d-flex flex-row align-items-center gap-2`}
                                >
                                    <SavingIndicator {...{
                                        color: defaultTheme.colors.primary, style: "spinner", message: <>
                                            Adding user:&nbsp;
                                            <span className="fw-bold" >{uName(showADUser)}</span>&nbsp;
                                            {actionMessage}
                                        </>, type: "saving"
                                    }} />
                                </motion.div> :
                                <AdUserDD
                                    needLoginUser={true}
                                    placeholder="Select AD User"
                                    avoidUser={filteredUsers.map((x) => x.userID)}
                                    initSelect={selectedUserId().toString()}
                                    updateUser={(u) => {
                                        if (u != null)
                                            setShowADUser(u.userEmail);
                                        else
                                            setShowADUser("");
                                    }}
                                />
                        }
                        <div className="w-100 d-flex flex-row justify-content-end mt-3">
                            <button className={showADUser == "" ? "btn btn-secondary" : "btn btn-outline-success"}
                                disabled={showADUser == ""} onClick={AddNewUser}>
                                {
                                    actionMessage != "" ?
                                        <Spinner animation="border" size="sm" /> : "Add"
                                }</button>
                        </div>
                    </motion.div>
                ) :
                    <div className="d-flex justify-content-end mt-3">
                        {/* <button
                            className="btn btn-outline-success j_g_uAd_Btn"
                            onClick={() => setShowADUser("")}
                        >
                            <span className="d-flex flex-row align-items-center gap-1">
                                <FaPlus /> Add User
                            </span>
                        </button> */}
                    </div>}
            </AnimatePresence>
        )
    }
    return (
        <div className="w-100">
            <InputGroup className="mb-3">
                <InputGroup.Text>
                    <FaSearch />
                </InputGroup.Text>
                <FormControl
                className="j_srch"
                    placeholder="Search users by name or email..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </InputGroup>
            {loading ? (
                <div className="d-flex flex-column align-items-center text-success mt-4">
                    <AnimatePresence>
                        <motion.div
                            animate={{ rotate: 360 }}
                            style={{
                                display: 'inline-block',
                                width: '40px',
                                height: '40px',
                                marginBottom: '10px'
                            }}
                            transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
                        >
                            <FaSpinner className="fa-spin mb-2" size={32} style={{
                                fontSize: '2.5rem',
                                color: '#198754',
                                width: '100%',
                                height: '100%'
                            }} />
                        </motion.div>
                    </AnimatePresence>
                    <span>Loading users...</span>
                </div>
            ) : filteredUsers.length === 0 ? (
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0 }}
                    className="d-flex flex-column align-items-center text-muted mt-4 border rounded-3 p-2 j_g_userC"
                >
                    <FaUserSlash size={40} className="mb-3" />
                    <div className="text-center">
                        <div className="fw-bold mb-1">
                            {users.length === 0
                                ? roleId > 0
                                    ? "No users are associated with this role yet."
                                    : `No users are assigned to this ${LabelConstants.RoleGroups} yet.`
                                : "No users match your search."}
                        </div>
                        {users.length === 0 && (
                            <div className="small text-secondary">
                                You can map users to this {roleId > 0 ? "role" : "group"} to see them here.
                            </div>
                        )}
                    </div>
                </motion.div>) : (
                <div className="d-flex flex-column gap-3 border p-4">
                    <AnimatePresence>
                        {filteredUsers.map((user) => (
                            <motion.div
                                key={user.userID}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0 }}
                                className={`border rounded p-3 shadow-sm d-flex align-items-center bg-theme-card transition-opacity j_g_userC ${showADUser !== null ? 'opacity-50' : 'opacity-100'}`}
                            >
                                <FaUserCircle size={28} className="me-3 text-success" />
                                <div>
                                    <div className="fw-bold">{user.userName}</div>
                                    <div className="text-muted-theme small">{user.email}</div>
                                </div>
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </div>
            )}
            {
                AddUserUI()
            }
        </div>
    );
}

export default RoleGroupUsers;
